import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sw',
  months: [
    'Januari',
    'Februari',
    'Machi',
    'Aprili',
    'Mei',
    'Juni',
    'Julai',
    'Agosti',
    'Septemba',
    'Oktoba',
    'Novemba',
    'Desemba',
  ],
  monthsShort: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ago', 'Sep', 'Okt', 'Nov', 'Des'],
  weekdays: ['Jumapili', 'Jumatatu', 'Jumanne', 'Jumatano', 'Alhamisi', 'Ijumaa', 'Jumamosi'],
  weekdaysMin: ['Jpl', 'Jtt', 'Jnn', 'Jtn', 'Alh', 'Ijm', 'Jms'],
  weekdaysShort: ['Jumapili', 'Jumatatu', 'Jumanne', 'Jumatano', 'Alhamisi', 'Ijumaa', 'Jumamosi'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: 'mwaka %s uliopita', other: 'miaka %s iliyopita' },
    M: { one: 'mwezi %s uliopita', other: 'miezi %s iliyopita' },
    w: { one: 'wiki %s iliyopita', other: 'wiki %s zilizopita' },
    d: { one: 'siku %s iliyopita', other: 'siku %s zilizopita' },
    h: { one: 'saa %s iliyopita', other: 'saa %s zilizopita' },
    m: { one: 'dakika %s iliyopita', other: 'dakika %s zilizopita' },
    s: { one: 'sekunde %s iliyopita', other: 'sekunde %s zilizopita' },
  },
  future: {
    y: { one: 'baada ya mwaka %s', other: 'baada ya miaka %s' },
    M: { one: 'baada ya mwezi %s', other: 'baada ya miezi %s' },
    w: { one: 'baada ya wiki %s', other: 'baada ya wiki %s' },
    d: { one: 'baada ya siku %s', other: 'baada ya siku %s' },
    h: { one: 'baada ya saa %s', other: 'baada ya saa %s' },
    m: { one: 'baada ya dakika %s', other: 'baada ya dakika %s' },
    s: { one: 'baada ya sekunde %s', other: 'baada ya sekunde %s' },
  },
  pastLong: {
    y: { one: 'mwaka %s uliopita', other: 'miaka %s iliyopita' },
    M: { one: 'mwezi %s uliopita', other: 'miezi %s iliyopita' },
    w: { one: 'wiki %s iliyopita', other: 'wiki %s zilizopita' },
    d: { one: 'siku %s iliyopita', other: 'siku %s zilizopita' },
    h: { one: 'saa %s iliyopita', other: 'saa %s zilizopita' },
    m: { one: 'dakika %s iliyopita', other: 'dakika %s zilizopita' },
    s: { one: 'Sekunde %s iliyopita', other: 'Sekunde %s zilizopita' },
  },
  futureLong: {
    y: { one: 'baada ya mwaka %s', other: 'baada ya miaka %s' },
    M: { one: 'baada ya mwezi %s', other: 'baada ya miezi %s' },
    w: { one: 'baada ya wiki %s', other: 'baada ya wiki %s' },
    d: { one: 'baada ya siku %s', other: 'baada ya siku %s' },
    h: { one: 'baada ya saa %s', other: 'baada ya saa %s' },
    m: { one: 'baada ya dakika %s', other: 'baada ya dakika %s' },
    s: { one: 'baada ya sekunde %s', other: 'baada ya sekunde %s' },
  },
  abbr: {
    y: { one: 'mwaka %s', other: 'miaka %s' },
    M: { one: 'mwezi %s', other: 'miezi %s' },
    w: { one: 'wiki %s', other: 'wiki %s' },
    d: { one: 'siku %s', other: 'siku %s' },
    h: { one: 'saa %s', other: 'saa %s' },
    m: { one: 'dak. %s', other: 'dak. %s' },
    s: { one: 'sek. %s', other: 'sek. %s' },
  },
  full: {
    y: { one: 'mwaka %s', other: 'miaka %s' },
    M: { one: 'mwezi %s', other: 'miezi %s' },
    w: { one: 'wiki %s', other: 'wiki %s' },
    d: { one: 'siku %s', other: 'siku %s' },
    h: { one: 'saa %s', other: 'saa %s' },
    m: { one: 'dakika %s', other: 'dakika %s' },
    s: { one: 'sekunde %s', other: 'sekunde %s' },
  },
  justNow: 'Sasa hivi',
  yesterday: 'Jana',
  today: 'Leo',
  tomorrow: 'Kesho',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'sw';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
